import React from 'react';
import closeIcon from 'assets/icons/videoClose.svg';
import previousIcon from 'assets/icons/previous.svg';
import nextIcon from 'assets/icons/next.svg';
import playIcon from 'assets/icons/play.svg';
import pauseIcon from 'assets/icons/pause.svg';
import mutedIcon from 'assets/icons/volume-level-0.svg';
import volumeIcon from 'assets/icons/volume-level-2.svg';
import captionOnIcon from 'assets/icons/caption-on.svg';
import captionOffIcon from 'assets/icons/caption-off.svg';

/**
 * @param {object} props
 * @param {'close'|'previous'|'next'|'play'|'pause'|'muted'|'volume'|'captionOn'|'captionOff'} props.type
 * @param {string} props.ariaLabel
 * @param {boolean} [props.ariaHidden]
 * @param {(event: React.MouseEvent<HTMLButtonElement>) => void} props.onClick
 * @param {string} [props.className]
 */
export const VideoIconButton = ({
  type,
  ariaLabel,
  ariaHidden,
  onClick,
  className,
}) => {
  const iconMap = {
    close: closeIcon,
    previous: previousIcon,
    next: nextIcon,
    play: playIcon,
    pause: pauseIcon,
    muted: mutedIcon,
    volume: volumeIcon,
    captionOn: captionOnIcon,
    captionOff: captionOffIcon,
  };

  const iconSrc = iconMap[type];

  if (!iconSrc) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
      aria-hidden={ariaHidden}
      tabIndex={ariaHidden ? -1 : 0}
      aria-label={ariaLabel}
      className={className}
      data-testid={`video-icon-button-${type}`}
    >
      <img src={iconSrc} alt="" role="presentation" />
    </button>
  );
};
